
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { AsApi, EmailTemplateTypeEnum, GetEmailTemplate, ClientApi, AsBroadcastTypeEnum } from "../../autogen";
import { SelectableProfile } from "../../types";
import UserSelector from "../molecules/UserSelector.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import Datepicker from "vue3-datepicker";
import { ja } from "date-fns/locale";
import FormMixin from "../../helpers/mixins/form";
type FormValues = { type: string; subject: string; message: string };

@Options({
  components: {
    Field,
    Form,
    FieldLabel,
    FieldError,
    FormError,
    ActionButton,
    Datepicker,
    DepartmentUserSelector,
    UserSelector
  }
})
export default class SendMailForm extends FormMixin {
  @Prop({ type: String }) type: EmailTemplateTypeEnum = EmailTemplateTypeEnum.As;
  @Prop({ type: Array }) targets: string[] = [];
  templates: GetEmailTemplate[] = [];
  currentTemplate?: Partial<GetEmailTemplate> = {};
  submissionMessage = "送信しました";
  formValues: FormValues = {
    type: "",
    subject: "",
    message: ""
  };
  locale = ja;
  selectedUsers: SelectableProfile[] = [];
  @Prop({ type: String }) broadcastType!: AsBroadcastTypeEnum;
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      type: yup.string().required(this.$t("input_required", { field: "テンプレート" })),
      subject: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "件名" })),
      message: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "テンプレート本文" }))
    });
  }
  async beforeMount() {
    const templatesResponse = await new ClientApi().getEmailTemplatesByType({
      emailTemplateType: this.type
    });
    this.templates = templatesResponse.data.map(d => Object.assign(d, { message: d.message.replace(/\\n/g, "\n") }));
  }
  onTemplateSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.value) {
      return (this.formValues = {
        type: "",
        subject: "",
        message: ""
      });
    }
    this.formValues.message = this.templates.find(t => t.emailTemplateId === target.value)!.message;
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      const response = await new AsApi().batchPostSendTask({
        asSendTaskBatchSendRequest: {
          asSendTaskIds: this.targets,
          broadcastType: this.broadcastType,
          emailSubject: values.subject,
          emailMessage: values.message
        }
      });
      const sendIds = response.data.asSendTaskIds;
      let errUsers: string[] = [];
      if (sendIds && this.targets.length > sendIds.length) {
        errUsers = this.targets.filter(user => sendIds.indexOf(user) == -1);
      }
      this.$emit("submitted", errUsers);
    });
  }
}
